import { Ref, ref } from 'vue';
import Actions from '@/dictionary/tracking/actions';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { trackIncentiveAction } from '@/utils/tracking/incentive-tracking';

/* v2 counterpart of PasswordInputBase.class.ts: tracks via the v2 store's getters instead of the
	v1 IncentiveBase/referrer, see docs/incentive-architecture.md. */
export default class PasswordInputBaseV2 {
	public input: Ref<HTMLInputElement | null> = ref(null);
	public inputText: Ref<string> = ref('');
	public fieldType: Ref<string> = ref('password');
	public toggleText: Ref<string> = ref('Show');
	public hasFocus: Ref<boolean> = ref(false);

	public constructor(public store: IIncentiveV2Store) {}

	private trackTogglePassword(action: string): void {
		trackIncentiveAction(
			Actions.TOGGLE_PASSWORD + ' - ' + action,
			this.store.getters.incentiveType(),
			this.store.getters.location(),
			this.store.getters.uniqueIdentifier(),
		);
	}

	public togglePassword(): void {
		if (this.fieldType.value === 'password') {
			this.fieldType.value = 'text';
			this.toggleText.value = 'Hide';
			this.trackTogglePassword('show');
		} else {
			this.fieldType.value = 'password';
			this.toggleText.value = 'Show';
			this.trackTogglePassword('hide');
		}
	}

	public setFocusOnInput(): void {
		const inputElement = this.input.value;
		if (typeof inputElement === 'undefined') {
			return;
		}
		inputElement?.focus();
	}

	public setFocused(hasFocus: boolean): void {
		this.hasFocus.value = hasFocus;
	}
}
